import { AxiosError, AxiosResponse } from "axios";

export const handleResponse = (response: any) => {
  if (!response || typeof response !== "object") {
    return new Error("server error");
  }

  const data = (response as any).data;

  if (data?.result) {
    return data.result;
  }
  if (data !== undefined) {
    return data;
  }

  return new Error("server error");
};

export function handleError(error: AxiosError) {
  console.log(error);
  return new Error("Server Error");
}
